export default function useSelectFile() {
  return {
    openFilePrompt: (accept, multiple) => new Promise((resolve) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = accept || '';
      input.multiple = multiple || '';
      input.style.display = 'none';

      function selectCallback() {
        resolve(input.files);
        input.removeEventListener('change', selectCallback);
        input.remove();
      }

      input.addEventListener('change', selectCallback);
      document.body.appendChild(input);
      input.click();
    }),
  };
}
